import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import type from './types';
import { toastr } from 'react-redux-toastr';

const URL_LEGAL_PROCESSES = `${BASE_API}/legal-processes`;
const URL_APPOINTMENTS = `${BASE_API}/legal-appointments`;
const URL_NEWS = `${BASE_API}/legal/news`;
const URL_CANCEL_APPOINTMENTS = `${BASE_API}/cancel-legal-appointments`

export const getProcessesList = () => {
  return (dispatch) => {
    dispatch({ type: 'LEGAL_PROCESSES_LOAD', payload: true });
    axios
      .get(`${URL_LEGAL_PROCESSES}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'LEGAL_PROCESSES_FETCHED',
            payload: response.data,
          },
        ]);
      })
      .catch((e) => {
        dispatch({ type: 'LEGAL_PROCESSES_LOAD', payload: false });
      });
  };
};

export const getAppointmentsList = () => {
  return (dispatch) => {
    dispatch({ type: 'LEGAL_APPOINTMENTS_LOAD', payload: true });
    axios
      .get(`${URL_APPOINTMENTS}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'LEGAL_APPOINTMENTS_FETCHED',
            payload: response.data,
          },
        ]);
      })
      .catch((e) => {
        dispatch({ type: 'LEGAL_APPOINTMENTS_LOAD', payload: false });
      });
  };
};

export const setLoading = (value) => {
  return (dispatch) => {
    dispatch([{ type: type.LIST_LOAD, payload: value }]);
  };
};

export const sendAppointmentRequest = (values, cleanup) => {
  return (dispatch) => {
    dispatch({ type: 'LEGAL_APPOINTMENTS_LOAD', payload: true });
    axios
      .post(`${URL_APPOINTMENTS}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([{ type: 'LEGAL_APPOINTMENTS_LOAD', payload: false }]);
        cleanup();
        toastr.success('Sucesso', 'Solicitação enviada com sucesso.');
      })
      .catch((e) => {
        dispatch([{ type: 'LEGAL_APPOINTMENTS_LOAD', payload: false }]);
        try {
          toastr.error('Erro', e.response.data.messages[0]);
        } catch {
          toastr.error('Erro');
        }
      });
  };
};

export const getNewsList = (page, tagId) => {
  return (dispatch) => {
    dispatch({
      type: type.NEWS_LIST_LOAD,
      payload: true,
    });
    axios
      .get(`${URL_NEWS}?page=${page}&tagId=${tagId}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch({
          type: type.NEWS_LIST_FETCHED,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch([
          {
            type: type.NEWS_LIST_LOAD,
            payload: false,
          },
        ]);
      });
  };
};

export const setNewsList = (value) => {
  return (dispatch) => {
    dispatch([{ type: type.NEWS_LIST_SET, payload: value }]);
  };
};

export const cancelAppointment = (escritorioId, appointmentId) => {
  return async (dispatch) => {
    dispatch({ type: 'CANCEL_LEGAL_APPOINTMENTS_LOAD', payload: true });
    try {
      await axios.post(
        URL_CANCEL_APPOINTMENTS,
        { escritorioId, appointmentId },
        {
          headers: {
            Authorization: JSON.parse(localStorage.getItem(USER_TOKEN)),
          },
        },
      );
      dispatch({ type: 'CANCEL_LEGAL_APPOINTMENTS_LOAD', payload: false });
      toastr.success('Agendamento cancelado com sucesso!');
    } catch (e) {
      dispatch({ type: 'CANCEL_LEGAL_APPOINTMENTS_LOAD', payload: false });

      const msg = e?.response?.data?.messages?.[0] ?? 'Erro ao cancelar agendamento';
      toastr.error('Erro', msg);
    }
  };
};